import { FunctionComponent } from 'react'
import { Switch } from 'react-router-dom'
import userProfile from 'shared/config/userProfile'

import Route from '../../../shared/routes/Route'
import { CnpjsVinculadosFactory } from '../factories/CnpjVinculados'
import { CreateUsuarioFactory } from '../factories/CreateUsuario'
import { VincularCnpjFactory } from '../factories/VincularCnpj'
import { EditUsuarioFactory } from '../factories/EditUsuario'
import { UsuariosVinculadosFactory } from '../factories/UsuarioVinculados'
import GerenciarConta from '../pages/GerenciarConta'

const UserRoutes: FunctionComponent = () => {
  return (
    <Switch>
      <Route
        path="/gerenciar-conta"
        isPrivate
        exact
        component={GerenciarConta}
      />
      <Route
        path="/cnpjs-vinculados"
        isPrivate
        exact
        component={CnpjsVinculadosFactory}
        scope={[userProfile.status.master, userProfile.status.admin]}
      />
      <Route
        path="/usuarios-vinculados"
        isPrivate
        exact
        component={UsuariosVinculadosFactory}
      />
      <Route
        path="/usuarios-vinculados/edit"
        isPrivate
        exact
        component={EditUsuarioFactory}
      />
      <Route
        path="/vincular-cnpj"
        isPrivate
        exact
        component={VincularCnpjFactory}
        scope={[userProfile.status.master, userProfile.status.admin]}
      />

      <Route
        path="/vincular-usuario"
        isPrivate
        exact
        component={CreateUsuarioFactory}
      />
    </Switch>
  )
}

export default UserRoutes
